/**
 * Custom search header for the unit tree
 * © EMETL Working Group
 * 
 * @author  Andrew Berger
 */

import React from "react"

import VM from "../../../../ViewModel/UnitTree.vm"
import EMETLSearchBar from "../../EMETLSearchBar"

export type EMETLUnitTreeSearchHeaderProps = {
    onSelect?: (node: any) => void,
    attributes?: string[],
    placeholder?: string,
}

const EMETLUnitTreeSearchHeader = (props?: EMETLUnitTreeSearchHeaderProps) => {
    const {
        placeholder = "Search Unit Tree",
        attributes = [
            "Name",
        ],
        onSelect = (_node) => {},
    } = props

    const selectNode = (node) => {
        onSelect(node)
    }

    const search = (needle, _attr, setMatches) => {
        if(needle.length && needle.length > 1)
            VM.searchUnits(needle, setMatches)
        else
            setMatches([])

    }

    return (
        <EMETLSearchBar
            options={attributes}
            select={selectNode}
            placeholder={placeholder} 
            handleSearch={search}
            name={attributes[0]}
            attribute={attributes[0]}
        />
    )
}

export default EMETLUnitTreeSearchHeader